<template>
  <WbLabelSrc v-if="label!=''" :for="inputId">
    {{ label }}
  </WbLabelSrc>  
  <div class="relative w-full inline-flex self-center">
    <IconUnfoldMore v-if="icon==''" class="h-10 w-10 absolute ml-2 top-2 right-1 pointer-events-none p-2 text-skin-b-list-base"/>
    <IconStacks v-if="icon=='IconStacks'" class="h-10 w-10 absolute ml-2 top-2 right-1 pointer-events-none p-2 text-skin-b-list-base"/>
    <IconAddRfid v-if="icon=='IconAddRfid'" class="h-10 w-10 absolute ml-2 top-2 right-1 pointer-events-none p-2 text-skin-b-list-base"/>
    <select
      :id="inputId"
      :value="modelValue"
      :ref="focus"
      :placeholder="placeholder"
      @change="updateValue"
      v-bind="$attrs"
      class="w-full mt-1 h-12 pl-4 pr-12 appearance-none bg-none truncate rounded-lg 
              cursor-pointer disabled:cursor-default 
              border-2 border-skin-b-list-bord
              font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
              bg-skin-b-list-back hover:bg-skin-b-list-head 
              focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0
              transition duration-150 ease-in-out">
      <slot name="options"></slot>
    </select>
  </div>
</template>

<script>
import WbLabelSrc from '../sources/SrcInputLabel.vue'
import IconUnfoldMore from '@/components/icons/IconUnfoldMore.vue'
import IconStacks from '@/components/icons/IconStacks.vue'
import IconAddRfid from '@/components/icons/IconAddRfid.vue'
 
 export default {
  components: {
    WbLabelSrc,
    IconUnfoldMore, IconStacks, IconAddRfid,
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Please select',
    },
    icon: {
      type: String,
      default: '',
    },
    focus: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      inputId: `Input-${Math.random().toString(36).substring(7)}`,
    };
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value);
    },
  },
};
</script>